import { useEffect, useState } from "react";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";
import axios from "axios";
import { LISTING_TYPE } from "../platformUtils";

function useGetPrice(amount: number, currency?: string) {
  const [tokenPrice, setTokenPrice] = useState(0);
  const [tokenPrice2, setTokenPrice2] = useState(undefined);
  const [errorState, setErrorState] = useState(false);
  const [fetchSuccess, setFetchSuccess] = useState(true);
  // TODO: remove property specific properties
  // TODO: actually write the function and use a hook from Moralis

  useEffect(() => {
    function fetchTokens() {
      try {
        axios({
          method: "GET",
          url: `https://api.coinconvert.net/convert/${
            currency ? currency : "ETH"
          }/usd?amount=${amount}`,
          headers: { accept: "application/json" },
        })
          .then((response) => {
            //console.log(response.data);
            setTokenPrice(response?.data);
            setTokenPrice2(response?.data);
            setErrorState(false);
          })
          .catch((error) => {
            console.warn("An error has occured while retreiving token price:", error.response.data.message);
            setTokenPrice(0);
            setErrorState(true);
            return;
          });
        setFetchSuccess(true);
      } catch (error) {
        console.error(
          "An error in fetching calculating your potential earnings.",
          error
        );
        return;
      }
    }
    if (amount) {
      fetchTokens();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, currency]);
  return { tokenPrice, tokenPrice2, errorState, fetchSuccess };
}

export default useGetPrice;
